import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class UserAdminService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  getUsersByWebIds(webIds): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getUsersByWebIds`;
    return this.http.post(REST_URL, { webIds });
  }

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/userAdmin`;
  }

  getRoleMapping(): object[] {
    return [
      {
        key: 'CLIENT',
        value: 'Client',
        role: [
          'ContractOwner',
          'PreviousContractOwner',
          'LifeInsured'
        ]
      },
      {
        key: 'ADVISOR',
        value: 'Advisor',
        role: ['Broker']
      },
      {
        key: 'BROKERAGE',
        value: 'Brokerage',
        role: ['BrokerHouse', 'Branch']
      },
      {
        key: 'CONSULTANT',
        value: 'Consultant',
        role: ['BrokerConsultant', 'BrokerConsultantBranch']
      },
      {
        key: 'TRUST',
        value: 'Trust',
        role: ['ContractOwner', 'PreviousContractOwner']
      },
      {
        key: 'WRAP_FUND_MANAGER',
        value: 'Wrap Fund Manager',
        role: ['WrapFundManager']
      },
      {
        key: 'COMPLIANCE_OFFICER',
        value: 'Compliance Officer',
        role: ['ComplianceOfficer']
      },
      {
        key: 'AUTH_SIGNATORY',
        value: 'Authorised Signatory',
        role: ['FeeAuthorisedSignatory', 'AuthorisedSignatory']
      }
    ];
  }
}
